export const formStructure = [[{
  name: 'nome',
  label: 'Nome',
  placeholder: 'Digite o nome do cliente',
  component: 'FormField',
  type: 'text',
  colProps: {
    md: 6
  },
  required: true,
  maxLength: 255,
  validation: {
    required: 'Nome é obrigatório'
  }
}, {
  name: 'cnpj',
  label: 'CNPJ',
  placeholder: 'Digite o CNPJ',
  component: 'MaskedInput',
  type: 'text',
  colProps: {
    md: 6
  },
  maxLength: 19,
  mask: [/[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '/', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/],
  guide: false
}], [{
  name: 'codigoIntegracao',
  label: 'Código de Integração',
  placeholder: 'Digite o código de integração',
  component: 'FormField',
  type: 'text',
  colProps: {
    md: 6
  },
  maxLength: 100
}, {
  name: 'telefone',
  label: 'Telefone',
  placeholder: 'Digite o telefone',
  component: 'MaskedInput',
  type: 'text',
  colProps: {
    md: 6
  },
  maxLength: 15,
  mask: ['(', /[0-9]/, /[0-9]/, ')', ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/],
  guide: false
}], [{
  name: 'email',
  label: 'Email',
  placeholder: 'Digite o email do cliente',
  component: 'FormField',
  type: 'email',
  colProps: {
    md: 12
  },
  maxLength: 255
}], [{
  name: 'observacoes',
  label: 'Observações',
  placeholder: 'Digite as observações',
  component: 'Textarea',
  type: 'textarea',
  colProps: {
    md: 12
  },
  rows: 4 // Observações é longtext no banco, sem limite

}]];
export const formSections = initialValues => [{
  title: `Detalhes do Cliente ${initialValues.nome || ''}`,
  rows: [0] // Nome e CNPJ

}, {
  title: 'Informações Adicionais',
  rows: [1, 2, 3] // Código de integração, telefone, email e observações

}]; // Função de validação do formulário

export const validateForm = values => {
  const errors = {}; // Validação do Nome

  if (!values.nome || values.nome.trim().length === 0) {
    errors.nome = 'Nome é obrigatório';
  }

  return errors;
};
